import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAppSelector } from '../../store/hooks'
import {
  selectOnboardingBDSource,
  selectOnboardingCode,
  selectOnboardingEmail,
  selectOnboardingEnabled,
  selectOnboardingUserId,
} from '../../store/auth/authSlice'
import { useCallback } from 'react'
import { useUTMHandler } from '../../common/utm'

const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL!

export const useNavigateToOnboarding = () => {
  const [searchParams] = useSearchParams()
  const { deleteUTMParams, appendUTMParams } = useUTMHandler()
  const navigate = useNavigate()
  const onboardingEnabled = useAppSelector(selectOnboardingEnabled) || searchParams.get('onboarding_enabled')?.toLowerCase() === 'true'
  const onboardingCode = useAppSelector(selectOnboardingCode) ?? searchParams.get('onboarding_code')
  const onboardingEmail = useAppSelector(selectOnboardingEmail) ?? searchParams.get('onboarding_email')
  const onboardingUserId = useAppSelector(selectOnboardingUserId) ?? searchParams.get('onboarding_user_id')
  const onboardingBdSource = useAppSelector(selectOnboardingBDSource) ?? searchParams.get('bd_source')
  const redirect = (url: string) => {
    window.location.href = url
  }

  return useCallback(
    (defaultNavigate: string = DASHBOARD_URL) => {
      let url = appendUTMParams(defaultNavigate)
      if (onboardingEnabled && onboardingCode) {
        const baseUrl = `/onboarding?onboarding_code=${onboardingCode}&email=${encodeURIComponent(onboardingEmail ?? '')}&user_id=${onboardingUserId}${
          onboardingBdSource ? `&bd_source=${onboardingBdSource}` : ''
        }`
        url = appendUTMParams(baseUrl)
      }
      deleteUTMParams()
      url.startsWith('http') ? redirect(url) : navigate(url)
    },
    [navigate, onboardingCode, onboardingEmail, onboardingUserId, onboardingEnabled, appendUTMParams, deleteUTMParams, onboardingBdSource],
  )
}
